import { seedExchangeIds } from './messageNormalize/seedExchangeIds'
import { assignAssistantVersions } from './messageNormalize/assignAssistantVersions'

/**
 * Normalize older message arrays into versioned exchanges.
 *
 * @param {unknown[]} list
 */
export function normalizeMessages(list) {
  return assignAssistantVersions(seedExchangeIds(list))
}
